import React from 'react';
import { Route } from 'react-router-dom';
import { ProductsLoadingDialog } from './products-loading-dialog/ProductsLoadingDialog';
import { ProductDeleteDialog } from './product-delete-dialog/ProductDeleteDialog';
import { ProductsUIProvider } from './ProductsUIContext';
import ProductsCard from './ProductsCard';

const ProductsPage = ({ history }) => {
  const ProductsUIEvents = {
    openCreateProductDialog: () => {
      history.push('/products/new');
    },
    openViewProductDialog: (id) => {
      history.push(`/products/${id}/edit`);
    },
    openDeleteProductDialog: (id) => {
      history.push(`/products/${id}/delete`);
    },
  };

  return (
    <ProductsUIProvider ProductsUIEvents={ProductsUIEvents}>
      <ProductsLoadingDialog />
      <Route path='/products/:id/delete'>
        {({ history, match }) => (
          <ProductDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push('/products');
            }}
          />
        )}
      </Route>
      <ProductsCard props />
    </ProductsUIProvider>
  );
};

export default ProductsPage;
